import { Link, useNavigate } from "react-router-dom";
import ReturnProductTable from "../components/ReturnProductTable";
import backLogo from "../assets/back-logo.png";
import SpecialOfferTable from "../components/SpecialOfferTable";

function SpecialOffers({ isVendorName }) {
  const navigate = useNavigate();

  return (
    <div>
      <div className="flex gap-1 items-center justify-between py-3 lg:py-10 px-2 bg-white lg:static sticky top-0 left-0 z-[100] lg:shadow-none shadow-md">
        <div
          className="flex items-center cursor-pointer"
          onClick={() => navigate(-1)}
        >
          <img
            src={backLogo}
            width={25}
            height={10}
            onClick={() => navigate(-1)}
            className="lg:hidden"
          />
          <div className="w-full flex justify-between items-center">
            <h1 className="text-xl md:text-2xl">Special Offers</h1>
          </div>
        </div>
      </div>
      <SpecialOfferTable isVendorName={isVendorName} />
    </div>
  );
}

export default SpecialOffers;
